import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import * as React from 'react'
import styles from './MandatoryCost.module.css'

export function MandatoryCosts(props: { mandatoryCosts: string[], mandatoryHeader: string }) {
  const { mandatoryCosts, mandatoryHeader } = props
  return (
    <div className={styles.mandatoryBox}>
      {mandatoryCosts && mandatoryCosts.length > 0 && mandatoryHeader && (
        <Typography className={styles.mandatoryHeaderText} variant="body-m-bold-snug">
          {mandatoryHeader ?? ''}
        </Typography>
      )}
      {mandatoryCosts?.map((mandatoryCost, index) => {
        return (
          <Typography key={index} className={cn(styles.mandatoryText)} variant="body-xs-regular-tight">
            {mandatoryCost ?? ''}
          </Typography>
        )
      })}
    </div>
  )
}
